module.exports = __webpack_public_path__ + "static/img/MIX2500_5.fbd10f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MIX2500_5.png
// module id = 8F8s
// module chunks = 1